import styled from 'styled-components';
import { Button, DatePicker, Form, Input } from 'antd';

import { Drawer } from '@/components/ui/Drawer';

export const SearchFormItem = styled(Form.Item)`
	&&& {
		margin: 0;
	}
`;

export const SearchInput = styled(Input)`
	height: 2.5rem;
	gap: 0.5rem;
	border-radius: 0.375rem;
	border-color: ${({ theme }) => theme.palette.secondary[150]};

	.ant-input-prefix {
		color: ${({ theme }) => theme.palette.secondary[400]};
	}

	.ant-input::placeholder {
		color: ${({ theme }) => theme.palette.secondary[250]};
	}
`;

export const FilterButton = styled(Button)`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 2.5rem;
	height: 2.5rem;
	padding: 0.5rem;
	border-radius: 0.25rem;
	color: ${({ theme }) => theme.palette.secondary[400]};

	svg {
		width: 1.5rem;
		height: 1.5rem;
	}
`;

export const UploadDatePicker = styled(DatePicker.RangePicker)`
	width: 100%;
`;

export const FiltersDrawer = styled(Drawer)`
	.ant-drawer-header {
		padding: 2rem 2.5rem;
		border-bottom: 1px solid ${({ theme }) => theme.palette.secondary[150]};
	}

	.ant-drawer-title .ant-typography {
		color: ${({ theme }) => theme.palette.secondary[400]};
		font-size: ${({ theme }) => theme.sizes.fonts.fs_2xl};
		font-weight: ${({ theme }) => theme.sizes.weights.semibold};
		line-height: ${({ theme }) => theme.sizes.line_heights.lh_lg};
		letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_md};
	}

	.close-icon {
		font-size: 1rem;
	}

	.ant-drawer-body {
		padding: 1rem 2.5rem 2rem;
	}

	.ant-drawer-footer {
		padding: 2rem 2.5rem;
		border-top: 1px solid ${({ theme }) => theme.palette.secondary[150]};
	}

	.ant-drawer-footer .ant-col:first-child .ant-btn {
		border-color: ${({ theme }) => theme.palette.secondary[150]};
		color: ${({ theme }) => theme.palette.secondary[400]};
	}
`;

export const Fields = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;

export const FieldFormItem = styled(Form.Item)`
	margin: 0;

	.ant-form-item-label {
		padding-bottom: 0.5rem;

		> label {
			height: auto;
			line-height: 1.5rem;
		}
	}
`;
